// @ts-strict-ignore
import { ActionType } from '../../../store/engine/constants';
import type { Action } from '../../../store/engine/types';
import { actionHasRules, getActionName, isActionOfType } from '../actions';
import { DEFAULT_WORKFLOW_ROUTING_PRECEDENCE_INDEX, PREVIEW_WORKFLOW_ROUTING_ACTION_NAME } from './constants';

// the sort order of this function should match the one at `layout.ts/sorting.ts/sortIslandNodesByPrecedenceIndex`
export function sortWorkflowRoutingActionsByPrecedenceIndex(
  workflowRoutingActions: Action[],
): Action[] {
  return workflowRoutingActions
    .sort((a, b) => b.workflow.precedenceIndex - a.workflow.precedenceIndex);
}


export function isPreviewWorkflowRoutingActionComplete(action: Action) {
  if (!action) {
    return false;
  }

  if (!isActionOfType(action, ActionType.WORKFLOW)) {
    return false;
  }

  const hasName = Boolean(getActionName(action));
  const hasRules = actionHasRules(action);
  const hasCorrectPrecedenceIndex = action.workflow.precedenceIndex
    !== DEFAULT_WORKFLOW_ROUTING_PRECEDENCE_INDEX;

  return hasName && hasRules && hasCorrectPrecedenceIndex;
}

export function isPreviewWorkflowRoutingAction(
  action: Action,
) {
  if (!action) {
    return false;
  }

  if (!isActionOfType(action, ActionType.WORKFLOW)) {
    return false;
  }

  const hasPreviewWorkflowRoutingActionName = getActionName(action)
    === PREVIEW_WORKFLOW_ROUTING_ACTION_NAME;


  if (hasPreviewWorkflowRoutingActionName) {
    return true;
  }

  const hasNoRules = !actionHasRules(action);
  const hasNotDefaultPrecedenceIndex = action.workflow.precedenceIndex
    !== DEFAULT_WORKFLOW_ROUTING_PRECEDENCE_INDEX;

  return hasNoRules && hasNotDefaultPrecedenceIndex;
}

